import React from 'react';

/**
 * Reusable Industry Badge Component
 * Displays an industry with consistent styling
 */
const IndustryBadge = ({ 
  industry, 
  variant = 'default', 
  size = 'md',
  className = '' 
}) => {
  const variants = {
    default: 'bg-gray-100 text-gray-800',
    primary: 'bg-blue-100 text-blue-800',
    success: 'bg-green-100 text-green-800',
    warning: 'bg-yellow-100 text-yellow-800',
    danger: 'bg-red-100 text-red-800',
    purple: 'bg-purple-100 text-purple-800',
    indigo: 'bg-indigo-100 text-indigo-800'
  };

  const sizes = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-3 py-1 text-sm',
    lg: 'px-4 py-2 text-base'
  };

  return (
    <span 
      className={`${variants[variant]} ${sizes[size]} rounded-full font-medium ${className}`}
    >
      {industry}
    </span>
  );
};

export default IndustryBadge;
